export default __webpack_public_path__ + "static/media/avatar_31.34778e71.png";